module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "piv"
    }
  }, [_vm._v(" First Mariner Books Edition 2002")])]), _c('a', {
    attrs: {
      "id": "piv"
    }
  }, [_c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Copyright © 1994 by Howard Frank Mosher")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')])]), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "piv"
    }
  }), _c('a', {
    attrs: {
      "href": "http://www.hmhco.com/popular-reading",
      "target": "_blank"
    }
  }, [_vm._v("www.hmhco.com")])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Cataloging-in-Publication Data is available.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v(" 0-618-24009-8")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("e"), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-547-52654-6"), _c('br'), _vm._v("\nv1.0714")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d48f4458","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 63
// module chunks = 0